<template>
    <svg width="82px" height="50px" viewBox="0 0 82 50" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: sketchtool 63.1 (101010) - https://sketch.com -->
        <title>55E1C40B-8C34-4E47-B45E-76DAB1915D23</title>
        <desc>Created with sketchtool.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="eŠkola" transform="translate(-1192.000000, -380.000000)" fill-rule="nonzero">
                <g id="ilustracija" transform="translate(635.000000, 140.000000)">
                    <g id="sum-it-white-svg" transform="translate(557.000000, 240.000000)">
                        <polygon id="Path" class="svg-blue" fill="#094776"
                            points="33.8213229 1.46771218 54.0538117 21.7758303 33.8213229 21.7758303"></polygon>
                        <path class="svg-blue"
                            d="M12.8699552,7.849631 C15.1221973,10.3099631 16.0111435,13.1881919 15.1782735,16.4483395 C14.258991,20.0461255 11.9019507,22.3302583 8.29376682,23.1439114 C5.12959641,23.8570111 2.35612108,22.9464945 0,20.7564576 L12.8699552,7.849631 Z"
                            id="Path" fill="#094776"></path>
                        <path class="svg-blue"
                            d="M3.7846861,15.6346863 C1.49843049,13.1245387 0.620515695,10.2103321 1.49659193,6.91881919 C2.43150224,3.40682657 4.76004484,1.15867159 8.29376682,0.343173432 C11.4781614,-0.394833948 14.2691031,0.51199262 16.6518834,2.72232472 C12.355157,7.03505535 8.0896861,11.3127306 3.7846861,15.6346863 Z"
                            id="Path" fill="#094776"></path>
                        <path class="svg-blue"
                            d="M16.0626233,22.6937269 L32.9286996,22.6937269 C32.8367713,25.50369 31.7602915,27.8090406 29.5025336,29.4363469 C26.6040359,31.5267528 23.4821525,31.7352399 20.3630269,29.9953875 C17.5720852,28.4428044 16.2225785,25.9289668 16.0626233,22.6937269 Z"
                            id="Path" fill="#094776"></path>
                        <polygon id="Path" fill="#094776" class="svg-blue"
                            points="55.1128251 1.00830258 55.1128251 21.5156827 44.8858072 11.2546125"></polygon>
                        <path class="svg-blue" fill="#094776"
                            d="M61.8162332,7.86531365 C61.2085874,7.86531365 60.6698879,7.85424354 60.1311883,7.86531365 C59.87287,7.87269373 59.7634753,7.81180812 59.7717489,7.52306273 C59.7938117,6.93634686 59.7781839,6.34870849 59.7781839,5.73154982 L66.0118386,5.73154982 C66.0118386,6.38929889 66.0191928,7.03136531 66.0008072,7.67343173 C66.0008072,7.73800738 65.8399327,7.84870849 65.7507623,7.85239852 C65.303991,7.87084871 64.8553812,7.8597786 64.4076906,7.86162362 C64.2845067,7.86162362 64.1613229,7.87177122 63.9930942,7.87915129 L63.9930942,21.849631 L61.8162332,21.849631 L61.8162332,7.86531365 Z"
                            id="Path"></path>
                        <path class="svg-blue"
                            d="M56.9136996,5.70756458 C57.6169507,5.70756458 58.2586099,5.70110701 58.9002691,5.71586716 C58.9692152,5.71586716 59.0556278,5.83671587 59.0969955,5.91881919 C59.1160652,5.99704855 59.1188815,6.07838006 59.1052691,6.15774908 L59.1052691,21.4086716 C59.1052691,21.8699262 59.1052691,21.8699262 58.6345964,21.8699262 C58.1639238,21.8699262 57.6923318,21.8579336 57.2216592,21.8699262 C56.9743722,21.8791513 56.9072646,21.7850554 56.9100224,21.5498155 C56.9201345,20.6512915 56.9100224,19.751845 56.9100224,18.8523985 L56.9100224,5.70756458 L56.9136996,5.70756458 Z"
                            id="Path" fill="#094776"></path>
                        <rect id="Rectangle" class="svg-red" fill="#EC1C24" x="16.0626233" y="4.85055351" width="16.8660762"
                            height="16.9252768"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: "sumit"
}
</script>
<style lang="scss">
.svg-blue {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.2) !important;
}
.svg-red {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.3) !important;
}
svg {
    &:hover {
        .svg-blue {
            fill: #094776 !important;
            transition: .4s ease;

        }
        .svg-red {
            fill: #EC1C24 !important;
            transition: .4s ease;

        }
    }
}
</style>